var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-footer',{attrs:{"color":"info","height":"50","app":""}},[_c('v-spacer'),_c('span',{staticClass:"white--text"},[_vm._v("© 2020 - "),_c('a',{staticStyle:{"color":"white","text-decoration":"none"},attrs:{"href":"https://andqxai.uz"}},[_vm._v("AndQXAI ")])]),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }